import { fromJS } from 'immutable';

export const actions = {
  ATTEMPT_SIGN_IN: 'ATTEMPT_SIGN_IN',
  ATTEMPT_SIGN_IN_SUCCEED: 'ATTEMPT_SIGN_IN_SUCCEED',
  ATTEMPT_SIGN_IN_FAILED: 'ATTEMPT_SIGN_IN_FAILED',
  ATTEMPT_SIGN_OUT: 'ATTEMPT_SIGN_OUT'
};

const defaultState = fromJS({
  loggedInUser: {},
  error: {},
  message: '',
  fields: {  
    isAccessDenied: false,
  },
});

export default (state = defaultState, { type }) => {
  switch (type) {
    case actions.ATTEMPT_SET_ACCESS_DENIED:
      return state
        .set('error', {})
        .set('message', '')
        .set('isAccessDenied', !state.get('isAccessDenied'));

    default:
      return state;
  }
};
